import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/acousticSensorScale.png'
import _imports_1 from '@/assets/img/intervals.png'


const _hoisted_1 = ["id", "data-bs-parent"]




export default /*@__PURE__*/_defineComponent({
  __name: 'DAS',
  props: {
  accordionInnerId: {
    type: String,
    required: true
  },
  accordionOuterId: {
    type: String,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.accordionInnerId,
    class: "accordion-collapse collapse accordion-border",
    "data-bs-parent": '#' + __props.accordionOuterId
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "p-3" }, [
      _createElementVNode("p", { class: "text-typography NKT-P2 mb-2" }, "Acoustic Sensors (dB)"),
      _createElementVNode("img", {
        src: _imports_0,
        class: "w-100 mx-auto mt-1",
        alt: "..."
      }),
      _createElementVNode("img", {
        src: _imports_1,
        class: "w-100 mx-auto mt-2 mb-2",
        alt: "..."
      })
    ], -1)
  ]), 8, _hoisted_1))
}
}

})